export enum PokeNames {
  BULBASAUR = "bulbasaur",
  IVYSAUR = "ivysaur",
  VENUSAUR = "venusaur",
  CHARMANDER = "charmander",
  CHARMELEON = "charmeleon",
  CHARIZARD = "charizard",
  SQUIRTLE = "squirtle",
  WARTORTLE = "wartortle",
  BLASTOISE = "blastoise",
  CATERPIE = "caterpie",
  METAPOD = "metapod",
  BUTTERFREE = "butterfree",
  WEEDLE = "weedle",
  KAKUNA = "kakuna",
  BEEDRILL = "beedrill",
  PIDGEY = "pidgey",
  PIDGEOTTO = "pidgeotto",
  PIDGEOT = "pidgeot",
  RATTATA = "rattata",
  RATICATE = "raticate",
  SPEAROW = "spearow",
  FEAROW = "fearow",
  EKANS = "ekans",
  ARBOK = "arbok",
  PIKACHU = "pikachu",
  RAICHU = "raichu",
  SANDSHREW = "sandshrew",
  SANDSLASH = "sandslash",
  NIDORAN_F = "nidoran-f",
  NIDORINA = "nidorina",
  NIDOQUEEN = "nidoqueen",
  NIDORAN_M = "nidoran-m",
  NIDORINO = "nidorino",
  NIDOKING = "nidoking",
  CLEFAIRY = "clefairy",
  CLEFABLE = "clefable",
  VULPIX = "vulpix",
  NINETALES = "ninetales",
  JIGGLYPUFF = "jigglypuff",
  WIGGLYTUFF = "wigglytuff",
  ZUBAT = "zubat",
  GOLBAT = "golbat",
  ODDISH = "oddish",
  GLOOM = "gloom",
  VILEPLUME = "vileplume",
  PARAS = "paras",
  PARASECT = "parasect",
  VENONAT = "venonat",
  VENOMOTH = "venomoth",
  DIGLETT = "diglett",
  DUGTRIO = "dugtrio",
  MEOWTH = "meowth",
  PERSIAN = "persian",
  PSYDUCK = "psyduck",
  GOLDUCK = "golduck",
  MANKEY = "mankey",
  PRIMEAPE = "primeape",
  GROWLITHE = "growlithe",
  ARCANINE = "arcanine",
  POLIWAG = "poliwag",
  POLIWHIRL = "poliwhirl",
  POLIWRATH = "poliwrath",
  ABRA = "abra",
  KADABRA = "kadabra",
  ALAKAZAM = "alakazam",
  MACHOP = "machop",
  MACHOKE = "machoke",
  MACHAMP = "machamp",
  BELLSPROUT = "bellsprout",
  WEEPINBELL = "weepinbell",
  VICTREEBEL = "victreebel",
  TENTACOOL = "tentacool",
  TENTACRUEL = "tentacruel",
  GEODUDE = "geodude",
  GRAVELER = "graveler",
  GOLEM = "golem",
  PONYTA = "ponyta",
  RAPIDASH = "rapidash",
  SLOWPOKE = "slowpoke",
  SLOWBRO = "slowbro",
  MAGNEMITE = "magnemite",
  MAGNETON = "magneton",
  FARFETCHD = "farfetchd",
  DODUO = "doduo",
  DODRIO = "dodrio",
  SEEL = "seel",
  DEWGONG = "dewgong",
  GRIMER = "grimer",
  MUK = "muk",
  SHELLDER = "shellder",
  CLOYSTER = "cloyster",
  GASTLY = "gastly",
  HAUNTER = "haunter",
  GENGAR = "gengar",
  ONIX = "onix",
  DROWZEE = "drowzee",
  HYPNO = "hypno",
  KRABBY = "krabby",
  KINGLER = "kingler",
  VOLTORB = "voltorb",
  ELECTRODE = "electrode",
  EXEGGCUTE = "exeggcute",
  EXEGGUTOR = "exeggutor",
  CUBONE = "cubone",
  MAROWAK = "marowak",
  HITMONLEE = "hitmonlee",
  HITMONCHAN = "hitmonchan",
  LICKITUNG = "lickitung",
  KOFFING = "koffing",
  WEEZING = "weezing",
  RHYHORN = "rhyhorn",
  RHYDON = "rhydon",
  CHANSEY = "chansey",
  TANGELA = "tangela",
  KANGASKHAN = "kangaskhan",
  HORSEA = "horsea",
  SEADRA = "seadra",
  GOLDEEN = "goldeen",
  SEAKING = "seaking",
  STARYU = "staryu",
  STARMIE = "starmie",
  MR_MIME = "mr-mime",
  SCYTHER = "scyther",
  JYNX = "jynx",
  ELECTABUZZ = "electabuzz",
  MAGMAR = "magmar",
  PINSIR = "pinsir",
  TAUROS = "tauros",
  MAGIKARP = "magikarp",
  GYARADOS = "gyarados",
  LAPRAS = "lapras",
  DITTO = "ditto",
  EEVEE = "eevee",
  VAPOREON = "vaporeon",
  JOLTEON = "jolteon",
  FLAREON = "flareon",
  PORYGON = "porygon",
  OMANYTE = "omanyte",
  OMASTAR = "omastar",
  KABUTO = "kabuto",
  KABUTOPS = "kabutops",
  AERODACTYL = "aerodactyl",
  SNORLAX = "snorlax",
  ARTICUNO = "articuno",
  ZAPDOS = "zapdos",
  MOLTRES = "moltres",
  DRATINI = "dratini",
  DRAGONAIR = "dragonair",
  DRAGONITE = "dragonite",
  MEWTWO = "mewtwo",
  MEW = "mew",
  CHIKORITA = "chikorita",
  BAYLEEF = "bayleef",
  MEGANIUM = "meganium",
  CYNDAQUIL = "cyndaquil",
  QUILAVA = "quilava",
  TYPHLOSION = "typhlosion",
  TOTODILE = "totodile",
  CROCONAW = "croconaw",
  FERALIGATR = "feraligatr",
  SENTRET = "sentret",
  FURRET = "furret",
  HOOTHOOT = "hoothoot",
  NOCTOWL = "noctowl",
  LEDYBA = "ledyba",
  LEDIAN = "ledian",
  SPINARAK = "spinarak",
  ARIADOS = "ariados",
  CROBAT = "crobat",
  CHINCHOU = "chinchou",
  LANTURN = "lanturn",
  PICHU = "pichu",
  CLEFFA = "cleffa",
  IGGLYBUFF = "igglybuff",
  TOGEPI = "togepi",
  TOGETIC = "togetic",
  NATU = "natu",
  XATU = "xatu",
  MAREEP = "mareep",
  FLAAFFY = "flaaffy",
  AMPHAROS = "ampharos",
  BELLOSSOM = "bellossom",
  MARILL = "marill",
  AZUMARILL = "azumarill",
  SUDOWOODO = "sudowoodo",
  POLITOED = "politoed",
  HOPPIP = "hoppip",
  SKIPLOOM = "skiploom",
  JUMPLUFF = "jumpluff",
  AIPOM = "aipom",
  SUNKERN = "sunkern",
  SUNFLORA = "sunflora",
  YANMA = "yanma",
  WOOPER = "wooper",
  QUAGSIRE = "quagsire",
  ESPEON = "espeon",
  UMBREON = "umbreon",
  MURKROW = "murkrow",
  SLOWKING = "slowking",
  MISDREAVUS = "misdreavus",
  UNOWN = "unown",
  WOBBUFFET = "wobbuffet",
  GIRAFARIG = "girafarig",
  PINECO = "pineco",
  FORRETRESS = "forretress",
  DUNSPARCE = "dunsparce",
  GLIGAR = "gligar",
  STEELIX = "steelix",
  SNUBBULL = "snubbull",
  GRANBULL = "granbull",
  QWILFISH = "qwilfish",
  SCIZOR = "scizor",
  SHUCKLE = "shuckle",
  HERACROSS = "heracross",
  SNEASEL = "sneasel",
  TEDDIURSA = "teddiursa",
  URSARING = "ursaring",
  SLUGMA = "slugma",
  MAGCARGO = "magcargo",
  SWINUB = "swinub",
  PILOSWINE = "piloswine",
  CORSOLA = "corsola",
  REMORAID = "remoraid",
  OCTILLERY = "octillery",
  DELIBIRD = "delibird",
  MANTINE = "mantine",
  SKARMORY = "skarmory",
  HOUNDOUR = "houndour",
  HOUNDOOM = "houndoom",
  KINGDRA = "kingdra",
  PHANPY = "phanpy",
  DONPHAN = "donphan",
  PORYGON2 = "porygon2",
  STANTLER = "stantler",
  SMEARGLE = "smeargle",
  TYROGUE = "tyrogue",
  HITMONTOP = "hitmontop",
  SMOOCHUM = "smoochum",
  ELEKID = "elekid",
  MAGBY = "magby",
  MILTANK = "miltank",
  BLISSEY = "blissey",
  RAIKOU = "raikou",
  ENTEI = "entei",
  SUICUNE = "suicune",
  LARVITAR = "larvitar",
  PUPITAR = "pupitar",
  TYRANITAR = "tyranitar",
  LUGIA = "lugia",
  HO_OH = "ho-oh",
  CELEBI = "celebi",
  TREECKO = "treecko",
  GROVYLE = "grovyle",
  SCEPTILE = "sceptile",
  TORCHIC = "torchic",
  COMBUSKEN = "combusken",
  BLAZIKEN = "blaziken",
  MUDKIP = "mudkip",
  MARSHTOMP = "marshtomp",
  SWAMPERT = "swampert",
  POOCHYENA = "poochyena",
  MIGHTYENA = "mightyena",
  ZIGZAGOON = "zigzagoon",
  LINOONE = "linoone",
  WURMPLE = "wurmple",
  SILCOON = "silcoon",
  BEAUTIFLY = "beautifly",
  CASCOON = "cascoon",
  DUSTOX = "dustox",
  LOTAD = "lotad",
  LOMBRE = "lombre",
  LUDICOLO = "ludicolo",
  SEEDOT = "seedot",
  NUZLEAF = "nuzleaf",
  SHIFTRY = "shiftry",
  TAILLOW = "taillow",
  SWELLOW = "swellow",
  WINGULL = "wingull",
  PELIPPER = "pelipper",
  RALTS = "ralts",
  KIRLIA = "kirlia",
  GARDEVOIR = "gardevoir",
  SURSKIT = "surskit",
  MASQUERAIN = "masquerain",
  SHROOMISH = "shroomish",
  BRELOOM = "breloom",
  SLAKOTH = "slakoth",
  VIGOROTH = "vigoroth",
  SLAKING = "slaking",
  NINCADA = "nincada",
  NINJASK = "ninjask",
  SHEDINJA = "shedinja",
  WHISMUR = "whismur",
  LOUDRED = "loudred",
  EXPLOUD = "exploud",
  MAKUHITA = "makuhita",
  HARIYAMA = "hariyama",
  AZURILL = "azurill",
  NOSEPASS = "nosepass",
  SKITTY = "skitty",
  DELCATTY = "delcatty",
  SABLEYE = "sableye",
  MAWILE = "mawile",
  ARON = "aron",
  LAIRON = "lairon",
  AGGRON = "aggron",
  MEDITITE = "meditite",
  MEDICHAM = "medicham",
  ELECTRIKE = "electrike",
  MANECTRIC = "manectric",
  PLUSLE = "plusle",
  MINUN = "minun",
  VOLBEAT = "volbeat",
  ILLUMISE = "illumise",
  ROSELIA = "roselia",
  GULPIN = "gulpin",
  SWALOT = "swalot",
  CARVANHA = "carvanha",
  SHARPEDO = "sharpedo",
  WAILMER = "wailmer",
  WAILORD = "wailord",
  NUMEL = "numel",
  CAMERUPT = "camerupt",
  TORKOAL = "torkoal",
  SPOINK = "spoink",
  GRUMPIG = "grumpig",
  SPINDA = "spinda",
  TRAPINCH = "trapinch",
  VIBRAVA = "vibrava",
  FLYGON = "flygon",
  CACNEA = "cacnea",
  CACTURNE = "cacturne",
  SWABLU = "swablu",
  ALTARIA = "altaria",
  ZANGOOSE = "zangoose",
  SEVIPER = "seviper",
  LUNATONE = "lunatone",
  SOLROCK = "solrock",
  BARBOACH = "barboach",
  WHISCASH = "whiscash",
  CORPHISH = "corphish",
  CRAWDAUNT = "crawdaunt",
  BALTOY = "baltoy",
  CLAYDOL = "claydol",
  LILEEP = "lileep",
  CRADILY = "cradily",
  ANORITH = "anorith",
  ARMALDO = "armaldo",
  FEEBAS = "feebas",
  MILOTIC = "milotic",
  CASTFORM = "castform",
  KECLEON = "kecleon",
  SHUPPET = "shuppet",
  BANETTE = "banette",
  DUSKULL = "duskull",
  DUSCLOPS = "dusclops",
  TROPIUS = "tropius",
  CHIMECHO = "chimecho",
  ABSOL = "absol",
  WYNAUT = "wynaut",
  SNORUNT = "snorunt",
  GLALIE = "glalie",
  SPHEAL = "spheal",
  SEALEO = "sealeo",
  WALREIN = "walrein",
  CLAMPERL = "clamperl",
  HUNTAIL = "huntail",
  GOREBYSS = "gorebyss",
  RELICANTH = "relicanth",
  LUVDISC = "luvdisc",
  BAGON = "bagon",
  SHELGON = "shelgon",
  SALAMENCE = "salamence",
  BELDUM = "beldum",
  METANG = "metang",
  METAGROSS = "metagross",
  REGIROCK = "regirock",
  REGICE = "regice",
  REGISTEEL = "registeel",
  LATIAS = "latias",
  LATIOS = "latios",
  KYOGRE = "kyogre",
  GROUDON = "groudon",
  RAYQUAZA = "rayquaza",
  JIRACHI = "jirachi",
  DEOXYS_NORMAL = "deoxys-normal",
  TURTWIG = "turtwig",
  GROTLE = "grotle",
  TORTERRA = "torterra",
  CHIMCHAR = "chimchar",
  MONFERNO = "monferno",
  INFERNAPE = "infernape",
  PIPLUP = "piplup",
  PRINPLUP = "prinplup",
  EMPOLEON = "empoleon",
  STARLY = "starly",
  STARAVIA = "staravia",
  STARAPTOR = "staraptor",
  BIDOOF = "bidoof",
  BIBAREL = "bibarel",
  KRICKETOT = "kricketot",
  KRICKETUNE = "kricketune",
  SHINX = "shinx",
  LUXIO = "luxio",
  LUXRAY = "luxray",
  BUDEW = "budew",
  ROSERADE = "roserade",
  CRANIDOS = "cranidos",
  RAMPARDOS = "rampardos",
  SHIELDON = "shieldon",
  BASTIODON = "bastiodon",
  BURMY = "burmy",
  WORMADAM_PLANT = "wormadam-plant",
  MOTHIM = "mothim",
  COMBEE = "combee",
  VESPIQUEN = "vespiquen",
  PACHIRISU = "pachirisu",
  BUIZEL = "buizel",
  FLOATZEL = "floatzel",
  CHERUBI = "cherubi",
  CHERRIM = "cherrim",
  SHELLOS = "shellos",
  GASTRODON = "gastrodon",
  AMBIPOM = "ambipom",
  DRIFLOON = "drifloon",
  DRIFBLIM = "drifblim",
  BUNEARY = "buneary",
  LOPUNNY = "lopunny",
  MISMAGIUS = "mismagius",
  HONCHKROW = "honchkrow",
  GLAMEOW = "glameow",
  PURUGLY = "purugly",
  CHINGLING = "chingling",
  STUNKY = "stunky",
  SKUNTANK = "skuntank",
  BRONZOR = "bronzor",
  BRONZONG = "bronzong",
  BONSLY = "bonsly",
  MIME_JR = "mime-jr",
  HAPPINY = "happiny",
  CHATOT = "chatot",
  SPIRITOMB = "spiritomb",
  GIBLE = "gible",
  GABITE = "gabite",
  GARCHOMP = "garchomp",
  MUNCHLAX = "munchlax",
  RIOLU = "riolu",
  LUCARIO = "lucario",
  HIPPOPOTAS = "hippopotas",
  HIPPOWDON = "hippowdon",
  SKORUPI = "skorupi",
  DRAPION = "drapion",
  CROAGUNK = "croagunk",
  TOXICROAK = "toxicroak",
  CARNIVINE = "carnivine",
  FINNEON = "finneon",
  LUMINEON = "lumineon",
  MANTYKE = "mantyke",
  SNOVER = "snover",
  ABOMASNOW = "abomasnow",
  WEAVILE = "weavile",
  MAGNEZONE = "magnezone",
  LICKILICKY = "lickilicky",
  RHYPERIOR = "rhyperior",
  TANGROWTH = "tangrowth",
  ELECTIVIRE = "electivire",
  MAGMORTAR = "magmortar",
  TOGEKISS = "togekiss",
  YANMEGA = "yanmega",
  LEAFEON = "leafeon",
  GLACEON = "glaceon",
  GLISCOR = "gliscor",
  MAMOSWINE = "mamoswine",
  PORYGON_Z = "porygon-z",
  GALLADE = "gallade",
  PROBOPASS = "probopass",
  DUSKNOIR = "dusknoir",
  FROSLASS = "froslass",
  ROTOM = "rotom",
  UXIE = "uxie",
  MESPRIT = "mesprit",
  AZELF = "azelf",
  DIALGA = "dialga",
  PALKIA = "palkia",
  HEATRAN = "heatran",
  REGIGIGAS = "regigigas",
  GIRATINA_ALTERED = "giratina-altered",
  CRESSELIA = "cresselia",
  PHIONE = "phione",
  MANAPHY = "manaphy",
  DARKRAI = "darkrai",
  SHAYMIN_LAND = "shaymin-land",
  ARCEUS = "arceus",
  VICTINI = "victini",
  SNIVY = "snivy",
  SERVINE = "servine",
  SERPERIOR = "serperior",
  TEPIG = "tepig",
  PIGNITE = "pignite",
  EMBOAR = "emboar",
  OSHAWOTT = "oshawott",
  DEWOTT = "dewott",
  SAMUROTT = "samurott",
  PATRAT = "patrat",
  WATCHOG = "watchog",
  LILLIPUP = "lillipup",
  HERDIER = "herdier",
  STOUTLAND = "stoutland",
  PURRLOIN = "purrloin",
  LIEPARD = "liepard",
  PANSAGE = "pansage",
  SIMISAGE = "simisage",
  PANSEAR = "pansear",
  SIMISEAR = "simisear",
  PANPOUR = "panpour",
  SIMIPOUR = "simipour",
  MUNNA = "munna",
  MUSHARNA = "musharna",
  PIDOVE = "pidove",
  TRANQUILL = "tranquill",
  UNFEZANT = "unfezant",
  BLITZLE = "blitzle",
  ZEBSTRIKA = "zebstrika",
  ROGGENROLA = "roggenrola",
  BOLDORE = "boldore",
  GIGALITH = "gigalith",
  WOOBAT = "woobat",
  SWOOBAT = "swoobat",
  DRILBUR = "drilbur",
  EXCADRILL = "excadrill",
  AUDINO = "audino",
  TIMBURR = "timburr",
  GURDURR = "gurdurr",
  CONKELDURR = "conkeldurr",
  TYMPOLE = "tympole",
  PALPITOAD = "palpitoad",
  SEISMITOAD = "seismitoad",
  THROH = "throh",
  SAWK = "sawk",
  SEWADDLE = "sewaddle",
  SWADLOON = "swadloon",
  LEAVANNY = "leavanny",
  VENIPEDE = "venipede",
  WHIRLIPEDE = "whirlipede",
  SCOLIPEDE = "scolipede",
  COTTONEE = "cottonee",
  WHIMSICOTT = "whimsicott",
  PETILIL = "petilil",
  LILLIGANT = "lilligant",
  BASCULIN_RED_STRIPED = "basculin-red-striped",
  SANDILE = "sandile",
  KROKOROK = "krokorok",
  KROOKODILE = "krookodile",
  DARUMAKA = "darumaka",
  DARMANITAN_STANDARD = "darmanitan-standard",
  MARACTUS = "maractus",
  DWEBBLE = "dwebble",
  CRUSTLE = "crustle",
  SCRAGGY = "scraggy",
  SCRAFTY = "scrafty",
  SIGILYPH = "sigilyph",
  YAMASK = "yamask",
  COFAGRIGUS = "cofagrigus",
  TIRTOUGA = "tirtouga",
  CARRACOSTA = "carracosta",
  ARCHEN = "archen",
  ARCHEOPS = "archeops",
  TRUBBISH = "trubbish",
  GARBODOR = "garbodor",
  ZORUA = "zorua",
  ZOROARK = "zoroark",
  MINCCINO = "minccino",
  CINCCINO = "cinccino",
  GOTHITA = "gothita",
  GOTHORITA = "gothorita",
  GOTHITELLE = "gothitelle",
  SOLOSIS = "solosis",
  DUOSION = "duosion",
  REUNICLUS = "reuniclus",
  DUCKLETT = "ducklett",
  SWANNA = "swanna",
  VANILLITE = "vanillite",
  VANILLISH = "vanillish",
  VANILLUXE = "vanilluxe",
  DEERLING = "deerling",
  SAWSBUCK = "sawsbuck",
  EMOLGA = "emolga",
  KARRABLAST = "karrablast",
  ESCAVALIER = "escavalier",
  FOONGUS = "foongus",
  AMOONGUSS = "amoonguss",
  FRILLISH = "frillish",
  JELLICENT = "jellicent",
  ALOMOMOLA = "alomomola",
  JOLTIK = "joltik",
  GALVANTULA = "galvantula",
  FERROSEED = "ferroseed",
  FERROTHORN = "ferrothorn",
  KLINK = "klink",
  KLANG = "klang",
  KLINKLANG = "klinklang",
  TYNAMO = "tynamo",
  EELEKTRIK = "eelektrik",
  EELEKTROSS = "eelektross",
  ELGYEM = "elgyem",
  BEHEEYEM = "beheeyem",
  LITWICK = "litwick",
  LAMPENT = "lampent",
  CHANDELURE = "chandelure",
  AXEW = "axew",
  FRAXURE = "fraxure",
  HAXORUS = "haxorus",
  CUBCHOO = "cubchoo",
  BEARTIC = "beartic",
  CRYOGONAL = "cryogonal",
  SHELMET = "shelmet",
  ACCELGOR = "accelgor",
  STUNFISK = "stunfisk",
  MIENFOO = "mienfoo",
  MIENSHAO = "mienshao",
  DRUDDIGON = "druddigon",
  GOLETT = "golett",
  GOLURK = "golurk",
  PAWNIARD = "pawniard",
  BISHARP = "bisharp",
  BOUFFALANT = "bouffalant",
  RUFFLET = "rufflet",
  BRAVIARY = "braviary",
  VULLABY = "vullaby",
  MANDIBUZZ = "mandibuzz",
  HEATMOR = "heatmor",
  DURANT = "durant",
  DEINO = "deino",
  ZWEILOUS = "zweilous",
  HYDREIGON = "hydreigon",
  LARVESTA = "larvesta",
  VOLCARONA = "volcarona",
  COBALION = "cobalion",
  TERRAKION = "terrakion",
  VIRIZION = "virizion",
  TORNADUS_INCARNATE = "tornadus-incarnate",
  THUNDURUS_INCARNATE = "thundurus-incarnate",
  RESHIRAM = "reshiram",
  ZEKROM = "zekrom",
  LANDORUS_INCARNATE = "landorus-incarnate",
  KYUREM = "kyurem",
  KELDEO_ORDINARY = "keldeo-ordinary",
  MELOETTA_ARIA = "meloetta-aria",
  GENESECT = "genesect",
  CHESPIN = "chespin",
  QUILLADIN = "quilladin",
  CHESNAUGHT = "chesnaught",
  FENNEKIN = "fennekin",
  BRAIXEN = "braixen",
  DELPHOX = "delphox",
  FROAKIE = "froakie",
  FROGADIER = "frogadier",
  GRENINJA = "greninja",
  BUNNELBY = "bunnelby",
  DIGGERSBY = "diggersby",
  FLETCHLING = "fletchling",
  FLETCHINDER = "fletchinder",
  TALONFLAME = "talonflame",
  SCATTERBUG = "scatterbug",
  SPEWPA = "spewpa",
  VIVILLON = "vivillon",
  LITLEO = "litleo",
  PYROAR = "pyroar",
  FLABEBE = "flabebe",
  FLOETTE = "floette",
  FLORGES = "florges",
  SKIDDO = "skiddo",
  GOGOAT = "gogoat",
  PANCHAM = "pancham",
  PANGORO = "pangoro",
  FURFROU = "furfrou",
  ESPURR = "espurr",
  MEOWSTIC_MALE = "meowstic-male",
  HONEDGE = "honedge",
  DOUBLADE = "doublade",
  AEGISLASH_SHIELD = "aegislash-shield",
  AEGISLASH = "aegislash",
  SPRITZEE = "spritzee",
  AROMATISSE = "aromatisse",
  SWIRLIX = "swirlix",
  SLURPUFF = "slurpuff",
  INKAY = "inkay",
  MALAMAR = "malamar",
  BINACLE = "binacle",
  BARBARACLE = "barbaracle",
  SKRELP = "skrelp",
  DRAGALGE = "dragalge",
  CLAUNCHER = "clauncher",
  CLAWITZER = "clawitzer",
  HELIOPTILE = "helioptile",
  HELIOLISK = "heliolisk",
  TYRUNT = "tyrunt",
  TYRANTRUM = "tyrantrum",
  AMAURA = "amaura",
  AURORUS = "aurorus",
  SYLVEON = "sylveon",
  HAWLUCHA = "hawlucha",
  DEDENNE = "dedenne",
  CARBINK = "carbink",
  GOOMY = "goomy",
  SLIGGOO = "sliggoo",
  GOODRA = "goodra",
  KLEFKI = "klefki",
  PHANTUMP = "phantump",
  TREVENANT = "trevenant",
  PUMPKABOO_AVERAGE = "pumpkaboo-average",
  GOURGEIST_AVERAGE = "gourgeist-average",
  BERGMITE = "bergmite",
  AVALUGG = "avalugg",
  NOIBAT = "noibat",
  NOIVERN = "noivern",
  XERNEAS = "xerneas",
  YVELTAL = "yveltal",
  ZYGARDE_50 = "zygarde-50",
  DIANCIE = "diancie",
  HOOPA = "hoopa",
  VOLCANION = "volcanion",
  ROWLET = "rowlet",
  DARTRIX = "dartrix",
  DECIDUEYE = "decidueye",
  LITTEN = "litten",
  TORRACAT = "torracat",
  INCINEROAR = "incineroar",
  POPPLIO = "popplio",
  BRIONNE = "brionne",
  PRIMARINA = "primarina",
  PIKIPEK = "pikipek",
  TRUMBEAK = "trumbeak",
  TOUCANNON = "toucannon",
  YUNGOOS = "yungoos",
  GUMSHOOS = "gumshoos",
  GRUBBIN = "grubbin",
  CHARJABUG = "charjabug",
  VIKAVOLT = "vikavolt",
  CRABRAWLER = "crabrawler",
  CRABOMINABLE = "crabominable",
  ORICORIO_BAILE = "oricorio-baile",
  CUTIEFLY = "cutiefly",
  RIBOMBEE = "ribombee",
  ROCKRUFF = "rockruff",
  LYCANROC = "lycanroc",
  LYCANROC_MIDDAY = "lycanroc-midday",
  WISHIWASHI_SOLO = "wishiwashi-solo",
  MAREANIE = "mareanie",
  TOXAPEX = "toxapex",
  MUDBRAY = "mudbray",
  MUDSDALE = "mudsdale",
  DEWPIDER = "dewpider",
  ARAQUANID = "araquanid",
  FOMANTIS = "fomantis",
  LURANTIS = "lurantis",
  MORELULL = "morelull",
  SHIINOTIC = "shiinotic",
  SALANDIT = "salandit",
  SALAZZLE = "salazzle",
  STUFFUL = "stufful",
  BEWEAR = "bewear",
  BOUNSWEET = "bounsweet",
  STEENEE = "steenee",
  TSAREENA = "tsareena",
  COMFEY = "comfey",
  ORANGURU = "oranguru",
  PASSIMIAN = "passimian",
  WIMPOD = "wimpod",
  GOLISOPOD = "golisopod",
  SANDYGAST = "sandygast",
  PALOSSAND = "palossand",
  PYUKUMUKU = "pyukumuku",
  TYPE_NULL = "type-null",
  SILVALLY = "silvally",
  MINIOR_RED_METEOR = "minior-red-meteor",
  KOMALA = "komala",
  TURTONATOR = "turtonator",
  TOGEDEMARU = "togedemaru",
  MIMIKYU_DISGUISED = "mimikyu-disguised",
  BRUXISH = "bruxish",
  DRAMPA = "drampa",
  DHELMISE = "dhelmise",
  JANGMO_O = "jangmo-o",
  HAKAMO_O = "hakamo-o",
  KOMMO_O = "kommo-o",
  TAPU_KOKO = "tapu-koko",
  TAPU_LELE = "tapu-lele",
  TAPU_BULU = "tapu-bulu",
  TAPU_FINI = "tapu-fini",
  COSMOG = "cosmog",
  COSMOEM = "cosmoem",
  SOLGALEO = "solgaleo",
  LUNALA = "lunala",
  NIHILEGO = "nihilego",
  BUZZWOLE = "buzzwole",
  PHEROMOSA = "pheromosa",
  XURKITREE = "xurkitree",
  CELESTEELA = "celesteela",
  KARTANA = "kartana",
  GUZZLORD = "guzzlord",
  NECROZMA = "necrozma",
  MAGEARNA = "magearna",
  MARSHADOW = "marshadow",
  POIPOLE = "poipole",
  NAGANADEL = "naganadel",
  STAKATAKA = "stakataka",
  BLACEPHALON = "blacephalon",
  ZERAORA = "zeraora",
  MELTAN = "meltan",
  MELMETAL = "melmetal",
  GROOKEY = "grookey",
  THWACKEY = "thwackey",
  RILLABOOM = "rillaboom",
  SCORBUNNY = "scorbunny",
  RABOOT = "raboot",
  CINDERACE = "cinderace",
  SOBBLE = "sobble",
  DRIZZILE = "drizzile",
  INTELEON = "inteleon",
  SKWOVET = "skwovet",
  GREEDENT = "greedent",
  ROOKIDEE = "rookidee",
  CORVISQUIRE = "corvisquire",
  CORVIKNIGHT = "corviknight",
  BLIPBUG = "blipbug",
  DOTTLER = "dottler",
  ORBEETLE = "orbeetle",
  NICKIT = "nickit",
  THIEVUL = "thievul",
  GOSSIFLEUR = "gossifleur",
  ELDEGOSS = "eldegoss",
  WOOLOO = "wooloo",
  DUBWOOL = "dubwool",
  CHEWTLE = "chewtle",
  DREDNAW = "drednaw",
  YAMPER = "yamper",
  BOLTUND = "boltund",
  ROLYCOLY = "rolycoly",
  CARKOL = "carkol",
  COALOSSAL = "coalossal",
  APPLIN = "applin",
  FLAPPLE = "flapple",
  APPLETUN = "appletun",
  SILICOBRA = "silicobra",
  SANDACONDA = "sandaconda",
  CRAMORANT = "cramorant",
  ARROKUDA = "arrokuda",
  BARRASKEWDA = "barraskewda",
  TOXEL = "toxel",
  TOXTRICITY = "toxtricity",
  SIZZLIPEDE = "sizzlipede",
  CENTISKORCH = "centiskorch",
  CLOBBOPUS = "clobbopus",
  GRAPPLOCT = "grapploct",
  SINISTEA = "sinistea",
  POLTEAGEIST = "polteageist",
  HATENNA = "hatenna",
  HATTREM = "hattrem",
  HATTERENE = "hatterene",
  IMPIDIMP = "impidimp",
  MORGREM = "morgrem",
  GRIMMSNARL = "grimmsnarl",
  OBSTAGOON = "obstagoon",
  PERRSERKER = "perrserker",
  CURSOLA = "cursola",
  SIRFETCHD = "sirfetchd",
  MR_RIME = "mr-rime",
  RUNERIGUS = "runerigus",
  MILCERY = "milcery",
  ALCREMIE = "alcremie",
  FALINKS = "falinks",
  PINCURCHIN = "pincurchin",
  SNOM = "snom",
  FROSMOTH = "frosmoth",
  STONJOURNER = "stonjourner",
  EISCUE_ICE = "eiscue-ice",
  INDEEDEE_MALE = "indeedee-male",
  MORPEKO_FULL_BELLY = "morpeko-full-belly",
  CUFANT = "cufant",
  COPPERAJAH = "copperajah",
  DRACOZOLT = "dracozolt",
  ARCTOZOLT = "arctozolt",
  DRACOVISH = "dracovish",
  ARCTOVISH = "arctovish",
  DURALUDON = "duraludon",
  DREEPY = "dreepy",
  DRAKLOAK = "drakloak",
  DRAGAPULT = "dragapult",
  ZACIAN = "zacian",
  ZAMAZENTA = "zamazenta",
  ETERNATUS = "eternatus",
  KUBFU = "kubfu",
  URSHIFU_SINGLE_STRIKE = "urshifu-single-strike",
  ZARUDE = "zarude",
  REGIELEKI = "regieleki",
  REGIDRAGO = "regidrago",
  GLASTRIER = "glastrier",
  SPECTRIER = "spectrier",
  CALYREX = "calyrex",
  WYRDEER = "wyrdeer",
  KLEAVOR = "kleavor",
  URSALUNA = "ursaluna",
  BASCULEGION_MALE = "basculegion-male",
  SNEASLER = "sneasler",
  OVERQWIL = "overqwil",
  ENAMORUS_INCARNATE = "enamorus-incarnate",
  SPRIGATITO = "sprigatito",
  FLORAGATO = "floragato",
  MEOWSCARADA = "meowscarada",
  FUECOCO = "fuecoco",
  CROCALOR = "crocalor",
  SKELEDIRGE = "skeledirge",
  QUAXLY = "quaxly",
  QUAXWELL = "quaxwell",
  QUAQUAVAL = "quaquaval",
  LECHONK = "lechonk",
  OINKOLOGNE_MALE = "oinkologne-male",
  TAROUNTULA = "tarountula",
  SPIDOPS = "spidops",
  NYMBLE = "nymble",
  LOKIX = "lokix",
  PAWMI = "pawmi",
  PAWMO = "pawmo",
  PAWMOT = "pawmot",
  TANDEMAUS = "tandemaus",
  MAUSHOLD = "maushold",
  FIDOUGH = "fidough",
  DACHSBUN = "dachsbun",
  SMOLIV = "smoliv",
  DOLLIV = "dolliv",
  ARBOLIVA = "arboliva",
  SQUAWKABILLY_GREEN_PLUMAGE = "squawkabilly-green-plumage",
  NACLI = "nacli",
  NACLSTACK = "naclstack",
  GARGANACL = "garganacl",
  CHARCADET = "charcadet",
  ARMAROUGE = "armarouge",
  CERULEDGE = "ceruledge",
  TADBULB = "tadbulb",
  BELLIBOLT = "bellibolt",
  WATTREL = "wattrel",
  KILOWATTREL = "kilowattrel",
  MASCHIFF = "maschiff",
  MABOSSTIFF = "mabosstiff",
  SHROODLE = "shroodle",
  GRAFAIAI = "grafaiai",
  BRAMBLIN = "bramblin",
  BRAMBLEGHAST = "brambleghast",
  TOEDSCOOL = "toedscool",
  TOEDSCRUEL = "toedscruel",
  KLAWF = "klawf",
  CAPSAKID = "capsakid",
  SCOVILLAIN = "scovillain",
  RELLOR = "rellor",
  RABSCA = "rabsca",
  FLITTLE = "flittle",
  ESPATHRA = "espathra",
  TINKATINK = "tinkatink",
  TINKATUFF = "tinkatuff",
  TINKATON = "tinkaton",
  WIGLETT = "wiglett",
  WUGTRIO = "wugtrio",
  BOMBIRDIER = "bombirdier",
  FINIZEN = "finizen",
  PALAFIN_ZERO = "palafin-zero",
  VAROOM = "varoom",
  REVAVROOM = "revavroom",
  CYCLIZAR = "cyclizar",
  ORTHWORM = "orthworm",
  GLIMMET = "glimmet",
  GLIMMORA = "glimmora",
  GREAVARD = "greavard",
  HOUNDSTONE = "houndstone",
  FLAMIGO = "flamigo",
  CETODDLE = "cetoddle",
  CETITAN = "cetitan",
  VELUZA = "veluza",
  DONDOZO = "dondozo",
  TATSUGIRI_CURLY = "tatsugiri-curly",
  ANNIHILAPE = "annihilape",
  CLODSIRE = "clodsire",
  FARIGIRAF = "farigiraf",
  DUDUNSPARCE_TWO_SEGMENT = "dudunsparce-two-segment",
  DUDUNSPARCE = "dudunsparce",
  KINGAMBIT = "kingambit",
  GREAT_TUSK = "great-tusk",
  SCREAM_TAIL = "scream-tail",
  BRUTE_BONNET = "brute-bonnet",
  FLUTTER_MANE = "flutter-mane",
  SLITHER_WING = "slither-wing",
  SANDY_SHOCKS = "sandy-shocks",
  IRON_TREADS = "iron-treads",
  IRON_BUNDLE = "iron-bundle",
  IRON_HANDS = "iron-hands",
  IRON_JUGULIS = "iron-jugulis",
  IRON_MOTH = "iron-moth",
  IRON_THORNS = "iron-thorns",
  FRIGIBAX = "frigibax",
  ARCTIBAX = "arctibax",
  BAXCALIBUR = "baxcalibur",
  GIMMIGHOUL = "gimmighoul",
  GHOLDENGO = "gholdengo",
  WO_CHIEN = "wo-chien",
  CHIEN_PAO = "chien-pao",
  TING_LU = "ting-lu",
  CHI_YU = "chi-yu",
  ROARING_MOON = "roaring-moon",
  IRON_VALIANT = "iron-valiant",
  KORAIDON = "koraidon",
  MIRAIDON = "miraidon",
  WALKING_WAKE = "walking-wake",
  IRON_LEAVES = "iron-leaves",
  DIPPLIN = "dipplin",
  POLTCHAGEIST = "poltchageist",
  SINISTCHA = "sinistcha",
  OKIDOGI = "okidogi",
  MUNKIDORI = "munkidori",
  FEZANDIPITI = "fezandipiti",
  OGERPON = "ogerpon",
  ARCHALUDON = "archaludon",
  HYDRAPPLE = "hydrapple",
  GOUGING_FIRE = "gouging-fire",
  RAGING_BOLT = "raging-bolt",
  IRON_BOULDER = "iron-boulder",
  IRON_CROWN = "iron-crown",
  TERAPAGOS = "terapagos",
  PECHARUNT = "pecharunt",
  DEOXYS_ATTACK = "deoxys-attack",
  DEOXYS_DEFENSE = "deoxys-defense",
  DEOXYS_SPEED = "deoxys-speed",
  WORMADAM_SANDY = "wormadam-sandy",
  WORMADAM_TRASH = "wormadam-trash",
  SHAYMIN_SKY = "shaymin-sky",
  GIRATINA_ORIGIN = "giratina-origin",
  ROTOM_HEAT = "rotom-heat",
  ROTOM_WASH = "rotom-wash",
  ROTOM_FROST = "rotom-frost",
  ROTOM_FAN = "rotom-fan",
  ROTOM_MOW = "rotom-mow",
  CASTFORM_SUNNY = "castform-sunny",
  CASTFORM_RAINY = "castform-rainy",
  CASTFORM_SNOWY = "castform-snowy",
  BASCULIN_BLUE_STRIPED = "basculin-blue-striped",
  DARMANITAN_ZEN = "darmanitan-zen",
  MELOETTA_PIROUETTE = "meloetta-pirouette",
  TORNADUS_THERIAN = "tornadus-therian",
  THUNDURUS_THERIAN = "thundurus-therian",
  LANDORUS_THERIAN = "landorus-therian",
  KYUREM_BLACK = "kyurem-black",
  KYUREM_WHITE = "kyurem-white",
  KELDEO_RESOLUTE = "keldeo-resolute",
  MEOWSTIC_FEMALE = "meowstic-female",
  AEGISLASH_BLADE = "aegislash-blade",
  PUMPKABOO_SMALL = "pumpkaboo-small",
  PUMPKABOO_LARGE = "pumpkaboo-large",
  PUMPKABOO_SUPER = "pumpkaboo-super",
  GOURGEIST_SMALL = "gourgeist-small",
  GOURGEIST_LARGE = "gourgeist-large",
  GOURGEIST_SUPER = "gourgeist-super",
  VENUSAUR_MEGA = "venusaur-mega",
  CHARIZARD_MEGA_X = "charizard-mega-x",
  CHARIZARD_MEGA_Y = "charizard-mega-y",
  BLASTOISE_MEGA = "blastoise-mega",
  ALAKAZAM_MEGA = "alakazam-mega",
  GENGAR_MEGA = "gengar-mega",
  KANGASKHAN_MEGA = "kangaskhan-mega",
  PINSIR_MEGA = "pinsir-mega",
  GYARADOS_MEGA = "gyarados-mega",
  AERODACTYL_MEGA = "aerodactyl-mega",
  MEWTWO_MEGA_X = "mewtwo-mega-x",
  MEWTWO_MEGA_Y = "mewtwo-mega-y",
  AMPHAROS_MEGA = "ampharos-mega",
  SCIZOR_MEGA = "scizor-mega",
  HERACROSS_MEGA = "heracross-mega",
  HOUNDOOM_MEGA = "houndoom-mega",
  TYRANITAR_MEGA = "tyranitar-mega",
  BLAZIKEN_MEGA = "blaziken-mega",
  GARDEVOIR_MEGA = "gardevoir-mega",
  MAWILE_MEGA = "mawile-mega",
  AGGRON_MEGA = "aggron-mega",
  MEDICHAM_MEGA = "medicham-mega",
  MANECTRIC_MEGA = "manectric-mega",
  BANETTE_MEGA = "banette-mega",
  ABSOL_MEGA = "absol-mega",
  GARCHOMP_MEGA = "garchomp-mega",
  LUCARIO_MEGA = "lucario-mega",
  ABOMASNOW_MEGA = "abomasnow-mega",
  FLOETTE_ETERNAL = "floette-eternal",
  LATIAS_MEGA = "latias-mega",
  LATIOS_MEGA = "latios-mega",
  SWAMPERT_MEGA = "swampert-mega",
  SCEPTILE_MEGA = "sceptile-mega",
  SABLEYE_MEGA = "sableye-mega",
  ALTARIA_MEGA = "altaria-mega",
  GALLADE_MEGA = "gallade-mega",
  AUDINO_MEGA = "audino-mega",
  SHARPEDO_MEGA = "sharpedo-mega",
  SLOWBRO_MEGA = "slowbro-mega",
  STEELIX_MEGA = "steelix-mega",
  PIDGEOT_MEGA = "pidgeot-mega",
  GLALIE_MEGA = "glalie-mega",
  DIANCIE_MEGA = "diancie-mega",
  METAGROSS_MEGA = "metagross-mega",
  KYOGRE_PRIMAL = "kyogre-primal",
  GROUDON_PRIMAL = "groudon-primal",
  RAYQUAZA_MEGA = "rayquaza-mega",
  HOOPA_UNBOUND = "hoopa-unbound",
  CAMERUPT_MEGA = "camerupt-mega",
  LOPUNNY_MEGA = "lopunny-mega",
  SALAMENCE_MEGA = "salamence-mega",
  BEEDRILL_MEGA = "beedrill-mega",
  RATTATA_ALOLA = "rattata-alola",
  RATICATE_ALOLA = "raticate-alola",
  RAICHU_ALOLA = "raichu-alola",
  SANDSHREW_ALOLA = "sandshrew-alola",
  SANDSLASH_ALOLA = "sandslash-alola",
  VULPIX_ALOLA = "vulpix-alola",
  NINETALES_ALOLA = "ninetales-alola",
  DIGLETT_ALOLA = "diglett-alola",
  DUGTRIO_ALOLA = "dugtrio-alola",
  MEOWTH_ALOLA = "meowth-alola",
  PERSIAN_ALOLA = "persian-alola",
  GEODUDE_ALOLA = "geodude-alola",
  GRAVELER_ALOLA = "graveler-alola",
  GOLEM_ALOLA = "golem-alola",
  GRIMER_ALOLA = "grimer-alola",
  MUK_ALOLA = "muk-alola",
  EXEGGUTOR_ALOLA = "exeggutor-alola",
  MAROWAK_ALOLA = "marowak-alola",
  ZYGARDE_10_POWER_CONSTRUCT = "zygarde-10-power-construct",
  ZYGARDE_50_POWER_CONSTRUCT = "zygarde-50-power-construct",
  ZYGARDE_COMPLETE = "zygarde-complete",
  ORICORIO_POM_POM = "oricorio-pom-pom",
  ORICORIO_PAU = "oricorio-pau",
  ORICORIO_SENSU = "oricorio-sensu",
  LYCANROC_MIDNIGHT = "lycanroc-midnight",
  WISHIWASHI_SCHOOL = "wishiwashi-school",
  MINIOR_ORANGE_METEOR = "minior-orange-meteor",
  MINIOR_YELLOW_METEOR = "minior-yellow-meteor",
  MINIOR_GREEN_METEOR = "minior-green-meteor",
  MINIOR_BLUE_METEOR = "minior-blue-meteor",
  MINIOR_INDIGO_METEOR = "minior-indigo-meteor",
  MINIOR_VIOLET_METEOR = "minior-violet-meteor",
  MINIOR_RED = "minior-red",
  MINIOR_ORANGE = "minior-orange",
  MINIOR_YELLOW = "minior-yellow",
  MINIOR_GREEN = "minior-green",
  MINIOR_BLUE = "minior-blue",
  MINIOR_INDIGO = "minior-indigo",
  MINIOR_VIOLET = "minior-violet",
  MIMIKYU_BUSTED = "mimikyu-busted",
  MAGEARNA_ORIGINAL = "magearna-original",
  PIKACHU_PARTNER_CAP = "pikachu-partner-cap",
  ROCKRUFF_OWN_TEMPO = "rockruff-own-tempo",
  LYCANROC_DUSK = "lycanroc-dusk",
  NECROZMA_DUSK = "necrozma-dusk",
  NECROZMA_DAWN = "necrozma-dawn",
  NECROZMA_ULTRA = "necrozma-ultra",
  PIKACHU_STARTER = "pikachu-starter",
  EEVEE_STARTER = "eevee-starter",
  PIKACHU_WORLD_CAP = "pikachu-world-cap",
  MEOWTH_GALAR = "meowth-galar",
  PONYTA_GALAR = "ponyta-galar",
  RAPIDASH_GALAR = "rapidash-galar",
  SLOWPOKE_GALAR = "slowpoke-galar",
  SLOWBRO_GALAR = "slowbro-galar",
  FARFETCHD_GALAR = "farfetchd-galar",
  WEEZING_GALAR = "weezing-galar",
  MR_MIME_GALAR = "mr-mime-galar",
  ARTICUNO_GALAR = "articuno-galar",
  ZAPDOS_GALAR = "zapdos-galar",
  MOLTRES_GALAR = "moltres-galar",
  SLOWKING_GALAR = "slowking-galar",
  CORSOLA_GALAR = "corsola-galar",
  ZIGZAGOON_GALAR = "zigzagoon-galar",
  LINOONE_GALAR = "linoone-galar",
  DARUMAKA_GALAR = "darumaka-galar",
  DARMANITAN_GALAR_STANDARD = "darmanitan-galar-standard",
  DARMANITAN_GALAR_ZEN = "darmanitan-galar-zen",
  YAMASK_GALAR = "yamask-galar",
  STUNFISK_GALAR = "stunfisk-galar",
  ZYGARDE_10 = "zygarde-10",
  CRAMORANT_GULPING = "cramorant-gulping",
  CRAMORANT_GORGING = "cramorant-gorging",
  TOXTRICITY_LOW_KEY = "toxtricity-low-key",
  EISCUE_NOICE = "eiscue-noice",
  INDEEDEE_FEMALE = "indeedee-female",
  MORPEKO_HANGRY = "morpeko-hangry",
  ZACIAN_CROWNED = "zacian-crowned",
  ZAMAZENTA_CROWNED = "zamazenta-crowned",
  ETERNATUS_ETERNAMAX = "eternatus-eternamax",
  URSHIFU_RAPID_STRIKE = "urshifu-rapid-strike",
  ZARUDE_DADA = "zarude-dada",
  CALYREX_ICE = "calyrex-ice",
  CALYREX_SHADOW = "calyrex-shadow",
  VENUSAUR_GMAX = "venusaur-gmax",
  CHARIZARD_GMAX = "charizard-gmax",
  BLASTOISE_GMAX = "blastoise-gmax",
  BUTTERFREE_GMAX = "butterfree-gmax",
  PIKACHU_GMAX = "pikachu-gmax",
  MEOWTH_GMAX = "meowth-gmax",
  MACHAMP_GMAX = "machamp-gmax",
  GENGAR_GMAX = "gengar-gmax",
  KINGLER_GMAX = "kingler-gmax",
  LAPRAS_GMAX = "lapras-gmax",
  EEVEE_GMAX = "eevee-gmax",
  SNORLAX_GMAX = "snorlax-gmax",
  GARBODOR_GMAX = "garbodor-gmax",
  MELMETAL_GMAX = "melmetal-gmax",
  RILLABOOM_GMAX = "rillaboom-gmax",
  CINDERACE_GMAX = "cinderace-gmax",
  INTELEON_GMAX = "inteleon-gmax",
  CORVIKNIGHT_GMAX = "corviknight-gmax",
  ORBEETLE_GMAX = "orbeetle-gmax",
  DREDNAW_GMAX = "drednaw-gmax",
  COALOSSAL_GMAX = "coalossal-gmax",
  FLAPPLE_GMAX = "flapple-gmax",
  APPLETUN_GMAX = "appletun-gmax",
  SANDACONDA_GMAX = "sandaconda-gmax",
  TOXTRICITY_AMPED_GMAX = "toxtricity-amped-gmax",
  CENTISKORCH_GMAX = "centiskorch-gmax",
  HATTERENE_GMAX = "hatterene-gmax",
  GRIMMSNARL_GMAX = "grimmsnarl-gmax",
  ALCREMIE_GMAX = "alcremie-gmax",
  COPPERAJAH_GMAX = "copperajah-gmax",
  DURALUDON_GMAX = "duraludon-gmax",
  URSHIFU_SINGLE_STRIKE_GMAX = "urshifu-single-strike-gmax",
  URSHIFU_RAPID_STRIKE_GMAX = "urshifu-rapid-strike-gmax",
  TOXTRICITY_LOW_KEY_GMAX = "toxtricity-low-key-gmax",
  GROWLITHE_HISUI = "growlithe-hisui",
  ARCANINE_HISUI = "arcanine-hisui",
  VOLTORB_HISUI = "voltorb-hisui",
  ELECTRODE_HISUI = "electrode-hisui",
  TYPHLOSION_HISUI = "typhlosion-hisui",
  QWILFISH_HISUI = "qwilfish-hisui",
  SNEASEL_HISUI = "sneasel-hisui",
  SAMUROTT_HISUI = "samurott-hisui",
  LILLIGANT_HISUI = "lilligant-hisui",
  ZORUA_HISUI = "zorua-hisui",
  ZOROARK_HISUI = "zoroark-hisui",
  BRAVIARY_HISUI = "braviary-hisui",
  SLIGGOO_HISUI = "sliggoo-hisui",
  GOODRA_HISUI = "goodra-hisui",
  AVALUGG_HISUI = "avalugg-hisui",
  DECIDUEYE_HISUI = "decidueye-hisui",
  DIALGA_ORIGIN = "dialga-origin",
  PALKIA_ORIGIN = "palkia-origin",
  BASCULIN_WHITE_STRIPED = "basculin-white-striped",
  BASCULEGION_FEMALE = "basculegion-female",
  ENAMORUS_THERIAN = "enamorus-therian",
  TAUROS_PALDEA_COMBAT_BREED = "tauros-paldea-combat-breed",
  TAUROS_PALDEA_BLAZE_BREED = "tauros-paldea-blaze-breed",
  TAUROS_PALDEA_AQUA_BREED = "tauros-paldea-aqua-breed",
  WOOPER_PALDEA = "wooper-paldea",
  OINKOLOGNE_FEMALE = "oinkologne-female",
  DUDUNSPARCE_THREE_SEGMENT = "dudunsparce-three-segment",
  PALAFIN_HERO = "palafin-hero",
  MAUSHOLD_FAMILY_OF_THREE = "maushold-family-of-three",
  TATSUGIRI_DROOPY = "tatsugiri-droopy",
  TATSUGIRI_STRETCHY = "tatsugiri-stretchy",
  SQUAWKABILLY_BLUE_PLUMAGE = "squawkabilly-blue-plumage",
  SQUAWKABILLY_YELLOW_PLUMAGE = "squawkabilly-yellow-plumage",
  SQUAWKABILLY_WHITE_PLUMAGE = "squawkabilly-white-plumage",
  GIMMIGHOUL_ROAMING = "gimmighoul-roaming",
  KORAIDON_LIMITED_BUILD = "koraidon-limited-build",
  KORAIDON_SPRINTING_BUILD = "koraidon-sprinting-build",
  KORAIDON_SWIMMING_BUILD = "koraidon-swimming-build",
  KORAIDON_GLIDING_BUILD = "koraidon-gliding-build",
  MIRAIDON_LOW_POWER_MODE = "miraidon-low-power-mode",
  MIRAIDON_DRIVE_MODE = "miraidon-drive-mode",
  MIRAIDON_AQUATIC_MODE = "miraidon-aquatic-mode",
  MIRAIDON_GLIDE_MODE = "miraidon-glide-mode",
  URSALUNA_BLOODMOON = "ursaluna-bloodmoon",
  OGERPON_WELLSPRING_MASK = "ogerpon-wellspring-mask",
  OGERPON_HEARTHFLAME_MASK = "ogerpon-hearthflame-mask",
  OGERPON_CORNERSTONE_MASK = "ogerpon-cornerstone-mask",
  TERAPAGOS_TERASTAL = "terapagos-terastal",
  TERAPAGOS_STELLAR = "terapagos-stellar",
}
